export class PathConstants {

    // Vista por defecto del portal.
    public static PATH_INICIO_PORTAL = '/dashboard';
    public static PATH_LOGIN = '/authentication/login';
    public static PATH_SOLICITAR_RECUPERACION_USUARIO = '/authentication/solicitar-recuperacion-usuario';
    public static PATH_RECUPERAR_USUARIO = '/authentication/recuperar-usuario';

    //Prestaciones
    public static PATH_FORMULARIO_SOLICITUD_CONSULTA_SALDOS:string= '/prestaciones/formulario-solicitud-consulta-saldos';

    //Gestor de archivos
    public static PATH_DESCARGAR_ARCHIVO:string='/gestor-archivos/descargar-archivo';

    /**
     * Req A-14054-H1 URL sentinela de permiso para mostrar el boton de Jen.
     * No es una ruta de navegacion; se usa con verificarUrlRole y opciones_menu.url_opcion.
     */
    public static PATH_FEATURE_CHATBOT = '/feature/chatbot';
}
